import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Close16 } from 'ui/icons/action/Close16';
import { useIsFirstCondition } from '../../../hooks/form';
import { useResetCondition } from '../../../hooks/form/fieldArrays/useResetCondition';
import { useSearchFieldContext } from '../context/SearchFieldContext';
import { useIsNoOptionSelected } from '../selects/hooks';

export const testIds = {
  button: 'dcb-reset-button',
};

export const ResetConditionButton = () => {
  const { changeDataType, changeOption } = useSearchFieldContext();

  const isNoOptionSelected = useIsNoOptionSelected();
  const isFirstCondition = useIsFirstCondition();
  const resetCondition = useResetCondition();

  if (!isFirstCondition || isNoOptionSelected) return null;

  return (
    <IconButton
      data-test={testIds.button}
      onClick={() => {
        resetCondition();
        changeDataType(undefined);
        changeOption(null);
      }}
      variant={BUTTON_VARIANTS.GHOST}
    >
      <Close16 />
    </IconButton>
  );
};
